/* @flow */
export default {
  ACTIVE_GLYPH_COLOR: 'brand',
  COLOR: 'thunder',
  GLYPH_COLOR: 'eclipse',
  GLYPH_SIZE: 'large',
};
